module.exports = __webpack_public_path__ + "img/ic_mpe_larm_normal.789c0b1b.png";